import { ErrorType } from '.';

export class ServerError extends Error {

  errors: ErrorType[];

  constructor(message: any, errors: ErrorType[]) {
      super(message);
      this.name = 'AppError';
      this.errors = errors;
  }

}
